export default __webpack_public_path__ + "static/media/yash bhagat.5070f45e.jfif";